import React from 'react';
import GridWrapper from '../../shared/components/layout/GridWrapper';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import CommanLiveTasks from './CommanLiveTasks';
import IndependentLiveTasks from './IndependentLiveTasks';
import GroupLiveTasks from './GroupLiveTasks';
import Loader from '../../shared/components/ui/Loader';
import { useSidebar } from '../../shared/contexts/SidebarContext';

import { useSelector, useDispatch } from 'react-redux';
import { setActiveTab } from '../../../uiSlice';

const LiveTasks = () => {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.ui.activeTab);
  const [isloading, setisLoading] = React.useState(false);
  const { collapsed } = useSidebar();

  const handleTabChange = (tab) => {
    dispatch(setActiveTab(tab));
  };

  const tabClass = (isActive) =>
    `text-[1rem] font-semibold transition-colors duration-200 pb-2 -mb-px border-b-2 ${
      isActive
        ? 'text-[#2A565E] border-[#2A565E]'
        : 'text-gray-400 border-transparent hover:text-gray-600'
    }`;

  return (
    <>
      <Loader isVisible={isloading} />
      <Layout>
        <div
          className={`fixed z-[10] top-0 transition-all duration-300 ease-in-out ${
            collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          }`}>
          <Header backArrow={false} data={{ name: 'Create Live Tasks' }} />
        </div>

        <div
          className={`fixed top-[4.1rem] z-30 bg-white px-6 py-3 transition-all duration-300 ease-in-out ${
            collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          }`}>
          <div className="flex gap-8 border-b border-gray-200">
            <button type="button" className={tabClass(activeTab === 'commonTasks')} onClick={() => handleTabChange('commonTasks')}>
              Common Tasks
            </button>
            <button
              type="button"
              className={tabClass(
                activeTab === 'independentAccommodation' || activeTab === 'accommodation'
              )}
              onClick={() => handleTabChange('independentAccommodation')}>
              Independent Tasks (Accommodation)
            </button>
            <button
              type="button"
              className={tabClass(activeTab === 'groupAccommodation')}
              onClick={() => handleTabChange('groupAccommodation')}>
              Group Task (Accommodation)
            </button>
          </div>
        </div>

        <GridWrapper width={100}>
          {activeTab === 'commonTasks' ? (
            <CommanLiveTasks setisLoading={setisLoading} />
          ) : activeTab === 'independentAccommodation' || activeTab === 'accommodation' ? (
            <IndependentLiveTasks setisLoading={setisLoading} />
          ) : activeTab === 'groupAccommodation' ? (
            <GroupLiveTasks setisLoading={setisLoading} />
          ) : (
            <CommanLiveTasks setisLoading={setisLoading} />
          )}
        </GridWrapper>
      </Layout>
    </>
  );
};

export default LiveTasks;
